<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="620px">
    <CreateWithCvForm :state="createCvDialog" :document="data" :exam="exam" @closeDialog="cancel" @refresh="refresh" />
    <UpdateWithCvForm :state="updateCvDialog" :document="data" :exam="exam" @closeDialog="cancel" @refresh="refresh" />
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM HỌC SINH</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div>
          <p class="ma-0 pb-6">Mã học sinh</p>
          <v-text-field v-model="code" hide-details outlined label="Mã hồ sơ" placeholder="Mã hồ sơ"></v-text-field>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" text @click="cancel" outlined>Hủy</v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn color="blue darken-4" text @click="createNoCode" outlined>Không</v-btn> -->
        <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { StudentExam } from '@/plugins/api'
import CreateWithCvForm from './CreateWithCvForm.vue'
import UpdateWithCvForm from './UpdateWithCvForm.vue'

export default {
  props: {
    state: Boolean,
    exam: String
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      createDialog: false,
      createCvDialog: false,
      updateCvDialog: false,
      code: '',
      data: {}
    }
  },
  methods: {
    cancel() {
      this.createCvDialog = false
      this.createDialog = false
      this.updateCvDialog = false
      this.$emit('closeDialog')
    },
    async confirm() {
      if (this.code) {
        this.$loading.active = true
        const res = await StudentExam.studentFromCode({ code: this.code, exam: this.exam })
        if (!res || res === 'Invalid code') {
          this.$alert.error('Mã không hợp lệ, xin hãy thử lại')
        } else if (res.studentHasExam) {
          this.$alert.warn('Học sinh với mã hồ sơ đã ở trong kỳ thi này')
        } else if (res.existedStudent) {
          this.data = res.existedStudent
          this.updateCvDialog = true
        } else if (res.existedCode) {
          this.data = res.existedCode
          this.createCvDialog = true
        } else {
          this.$alert.error(`Lỗi tạo học sinh: ${res.error ? res.error : ''}`)
        }
        this.$loading.active = false
      }
    },
    createNoCode() {
      this.createDialog = true
      this.$emit('closeDialog')
    },
    refresh() {
      this.$emit('refresh')
    }
  },
  components: { CreateWithCvForm, UpdateWithCvForm }
}
</script>
